export const CheckedCircleFilled: React.FC<React.HTMLProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.3335 20.0002C3.3335 10.7952 10.7952 3.3335 20.0002 3.3335C29.2052 3.3335 36.6668 10.7952 36.6668 20.0002C36.6668 29.2052 29.2052 36.6668 20.0002 36.6668C10.7952 36.6668 3.3335 29.2052 3.3335 20.0002ZM15.6618 18.2367L18.8902 21.465L26.0102 14.345H28.3685V16.7017L20.0685 25H17.7118L13.3052 20.5933V18.2367H15.6618Z"
      fill="#23E5DB"
    />
  </svg>
);
